import jsCookie from 'js-cookie'
import * as kwsdk from 'kwsdk'

class LocationClazz {
  public getHostName(url: string) {
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i)
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
      return match[2]
    } else {
      return null
    }
  }
  public getDomain(url: string) {
    const hostName = this.getHostName(url)
    let domain = hostName

    if (hostName != null) {
      const parts = hostName.split('.').reverse()

      if (parts != null && parts.length > 1) {
        domain = parts[1] + '.' + parts[0]

        if (hostName.toLowerCase().indexOf('.co.uk') != -1 && parts.length > 2) {
          domain = parts[2] + '.' + domain
        }
      }
    }

    return domain
  }
}

const loc = new LocationClazz()

// eslint-disable-next-line @typescript-eslint/no-empty-function
const newJc: any = function() {}

for (const [key, value] of Object.entries(jsCookie)) {
  if (key === 'set') {
    const newVal = (...args: any) => {
      const domain = loc.getDomain(location.href)
      if (!args[2]) {
        args[2] = { domain, expires: 1 } // cookie默认设置1天
      } else if (args[2]) {
        args[2].domain = args[2].domain || domain
        args[2].expires = args[2].expires || 1
      }
      value(...args)
    }
    newJc[key] = newVal
  } else if (key === 'remove') {
    const newVal = (...args: any) => {
      const domain = loc.getDomain(location.href)
      if (!args[1]) {
        args[1] = { domain }
      } else if (args[1] && !args[1].domain) {
        args[1].domain = domain
      }
      value(...args)
    }
    newJc[key] = newVal
  } else {
    newJc[key] = value
  }
}

export const cookies = newJc

export const clearAllCookies = function() {
  Object.keys(cookies.get()).forEach(function(cookieName) {
    cookies.remove(cookieName)
  })
}

export function getDevice(): string {
  const ua = navigator.userAgent
  const src = cookies.get('source')
  if (src === 'ios') {
    return 'ios'
  } else if (src === 'android') {
    return 'android'
  } else if (/MicroMessenger/i.test(ua)) {
    return 'weixin'
  } else if (/Mobile/i.test(ua)) {
    return 'mobile'
  }
  return 'other'
}

export function isAndroidApp(): boolean {
  return getDevice() === 'android'
}

export function isIosApp(): boolean {
  return getDevice() === 'ios'
}

export function isApp(): boolean {
  return isAndroidApp() || isIosApp()
}

export function isWeixin(): boolean {
  return getDevice() === 'weixin'
}

export function isRkhy(): boolean {
  const source = cookies.get('source')
  const apptype = cookies.get('apptype')
  return (source === 'android' || source === 'ios') && apptype === 'rkhy'
}

export function isMmz() {
  const source = cookies.get('source')
  const appcode = cookies.get('appcode')
  if (location.href.includes('hzwMmz=1') && isHzwApp()) return true
  return (source === 'android' || source === 'ios') && appcode === 'MMZ_MALL'
}

export function isHzwApp(): boolean {
  // app特指孩子王app，不包括人客合一
  const source = cookies.get('source')
  const appcode = cookies.get('appcode')
  return (source === 'android' || source === 'ios') && appcode === 'HZWMALL'
}

/* 同城亲子小程序 */
export async function isTCQZMiniprogram(): Promise<boolean> {
  const miniprogramid = cookies.get('miniprogramid')
  if ('wxffd73aa1225d87d6' === miniprogramid) {
    return await kwsdk.isMiniprogram()
  } else {
    return false
  }
}

export async function getSelectterm() {
  if (isHzwApp()) {
    return '孩子王APP'
  } else if (isRkhy()) {
    return '人客合一'
  } else if (await isTCQZMiniprogram()) {
    return '同城亲子小程序'
  } else if (await isMiniprogram()) {
    return '小程序'
  } else if (isWeixin()) {
    return 'H5(微信商城)'
  } else {
    return ''
  }
}

export async function isMiniprogram(): Promise<boolean> {
  const miniprogramid = cookies.get('miniprogramid')
  if ('wx38c03f55ea0ab651' === miniprogramid) {
    return await kwsdk.isMiniprogram()
  } else {
    return false
  }
}

export function isLogin(): boolean {
  const uid = cookies.get('uid')
  const skey = cookies.get('skey')
  return uid && skey
}

export const uid = cookies.get('uid') || ''
export const skey = cookies.get('skey') || ''
export const guid = cookies.get('guid') || ''
